export default function Footer() {
	return (
		<footer id="contact" className="flex flex-col">
			<section className="flex flex-col space-x-12 space-y-4 bg-background pb-20 pt-12 sm:flex-row sm:space-y-0">
				<div className="pl-24">
					<img src="/img/luke.jpg" className="aspect-square w-52" alt="Luke" />
				</div>
				<div className="flex flex-col">
					<p className="text-2xl">Luke Ungarino</p>
					<p className="pb-4 text-base">Executive Director</p>
					{/* <p className="pb-12 text-xl">(220)123-7819</p> */}
				</div>
			</section>
			<section className="flex h-40 flex-col justify-between bg-accent-dark pb-2 pt-12 text-center text-white">
				<div>
					242 W. Livingston Pl.
					<br />
					Metairie, LA, 70005
				</div>
				<div>
					Via Nova is an independent 501(c)(3) organization. All donations are
					legally tax-deductible.
				</div>
			</section>
		</footer>
	)
}
